/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AnswersControllerCreateMutationRequest, AnswersControllerCreateMutationResponse, AnswersControllerCreate400, AnswersControllerCreate401, AnswersControllerCreate403 } from "../../models/checklistsController/AnswersControllerCreate";

function getAnswersControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-answers` as const }  
  return res
}

/**
 * @description Requires Edit reviews or Edit Playbooks (matching the parent application's template kind) — the permission that controls responding to an already-run application.
 * @summary Create a new checklist answer
 * {@link /api/v1/checklist-answers}
 */
export async function answersControllerCreate(data?: AnswersControllerCreateMutationRequest, config: Partial<RequestConfig<AnswersControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<AnswersControllerCreateMutationResponse, ResponseErrorConfig<AnswersControllerCreate400 | AnswersControllerCreate401 | AnswersControllerCreate403>, AnswersControllerCreateMutationRequest>({ method : "POST", url : getAnswersControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}